export const onPasteHelper = (setValue, trigger) => {
	const inputElements = document.querySelectorAll("input");

	inputElements.forEach((element) =>
		element.addEventListener("paste", (e) => {
			e.preventDefault();
			if (element?.name !== "") {
				let { value, selectionStart, selectionEnd } = e.target;
				let pastedValue = e.clipboardData.getData("text").trim();
				let pre = value.substring(0, selectionStart);
				let post = value.substring(selectionEnd, value.length);
				value = (pre + pastedValue + post).trim();
				setValue(element.name, value);
				trigger(element.name);
			}
		})
	);
};
